/*  HOW LONG EACH PREVIEW IS, so the player can print a duration before it has downloaded
    anything. Keyed by filename without the extension, the same convention as ev-peaks.js
    and for the same reason: the previews were WAV when this was measured and are AAC now.

    THIS EXISTS BECAUSE OF WHAT THE ALTERNATIVE LOOKED LIKE. Without it the readout sits
    at a placeholder until a buffer decodes, so a bank screen loads showing eight rows of
    nothing where the times should be, and they fill in one at a time as you click around.
    A duration is four bytes of knowledge; making somebody download 100KB to learn it is
    the kind of detail the whole minimal treatment lives or dies on.

    MEASURED FROM THE SOURCE FILES, not guessed, not rounded up. Anything missing here
    simply falls back to the decoded buffer once it arrives, so an unlisted preview is a
    cosmetic gap and never a broken player.  */

window.EV_DUR = {
  "FALLOUT_PAD__2": 6.86,
  "PEDAL_MAGIC_SYNTH_KEY_2": 6.86,
  "PEDAL_GONE_WRONG_SYNTH_KEY_2": 6.86,
  "POWERDAY_LOFI_KEY_2": 6.86,
  "OMINOUS_SYNTH_KEY_2": 6.86,
  "MULTI_KEYS_PREVIEW_10": 6.83,
  "LOCUST_AMBIENT_PAD_2": 6.86,
  "ENHANCEMENT_PRESET": 13.71
};